import { render } from "./WaterMeasurements.vue?vue&type=template&id=6bf7686e"
import script from "./WaterMeasurements.vue?vue&type=script&lang=js"
export * from "./WaterMeasurements.vue?vue&type=script&lang=js"
script.render = render

export default script